// extracted by mini-css-extract-plugin
export default {"mini-card":"mini-card_mini-card__Vxy80"};